import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import type React from 'react';

interface EmailSelectOptionProps {
  props: React.HTMLAttributes<HTMLLIElement> & { key: any };
  option: Record<string, any>;
}

export const EmailSelectOption: React.FC<EmailSelectOptionProps> = ({ props, option }) => {
  const { ...optionProps } = props;

  return (
    <Box {...optionProps} key={option?.id} component="li" gap={2}>
      <Avatar
        sx={(theme) => ({
          '& .MuiChip-root': {
            backgroundColor: theme.palette.neutral.main,
            color: theme.palette.common.white,
          },
          color: theme.palette.common.white,
          background: theme.palette.neutral.main,
        })}
        src={option?.avatar}
      >
        {option?.firstName?.charAt(0) + option?.lastName?.charAt(0)}
      </Avatar>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <Typography fontSize={16} fontWeight={400} color="text.primary">
          {option?.fullName ?? ''}
        </Typography>
        <Typography variant="body2" color="text.secondary" fontSize={14} fontWeight={400}>
          {option?.email}
        </Typography>
      </div>
    </Box>
  );
};
